import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';
import useAppStore from '../stores/appStore';

/**
 * Custom hook that replaces useAppContext
 * Provides the same API but with better performance via Zustand
 */
export const useApp = () => {
  const navigate = useNavigate();
  const { address } = useAccount();
  
  const {
    socket,
    username,
    currentRoom,
    board,
    draw,
    connectionStatus,
    messages,
    isSignedIn,
    setUsername,
    setCurrentRoom,
    joinGame: joinGameAction,
    leaveRoom: leaveRoomAction,
    signOut: signOutAction,
    // Removed: All session management functions
  } = useAppStore();

  // Wrapped actions that include navigation
  const joinGame = (roomId = 'public') => {
    joinGameAction(roomId, navigate, address);
  };

  const leaveRoom = () => {
    leaveRoomAction(navigate);
  };

  const signOut = () => {
    signOutAction(navigate);
  };

  return {
    // State
    socket,
    username,
    currentRoom,
    board,
    draw,
    connectionStatus,
    messages,
    isSignedIn,
    
    // Actions
    setUsername,
    setCurrentRoom,
    joinGame,
    leaveRoom,
    signOut,
    
    // Additional data
    address,
  };
};

export default useApp;
